import React, {useId} from 'react';
import {Button, Divider, Stack} from '@mui/material';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import getFormattedHour from 'presentation/pages/private/booking/utils/getFormattedHour';
import {translations} from 'presentation/translations-new';

import {HOUR_BUTTON_HEIGHT} from './constants';
import {useExpandableHourList} from './hooks/useExpandableHourList';
import {StyledHourList} from './styles';
import {ExpandableHourListProps} from './types';

const {seeMoreSchedules} = translations['pt-br'].privateFlow.bookingFlow.professionalFlow;
const {seeLess} = translations['pt-br'].commons;

export function ExpandableHourList({
	availableTimes,
	flowType,
	onSelectHour,
}: ExpandableHourListProps) {
	const {listRef, isExpanded, showToggle, handleToggleExpanded} = useExpandableHourList(
		availableTimes.length,
	);
	const hourListId = useId();

	return (
		<Stack gap={2}>
			<StyledHourList id={hourListId} ref={listRef} $isExpanded={isExpanded}>
				{availableTimes.map((hour, index) => (
					<Button
						key={`${hour}-${index}`}
						data-test="button-hour"
						variant="outlined"
						sx={{
							width: '100%',
							minWidth: 0,
							height: HOUR_BUTTON_HEIGHT,
							px: 1,
							borderRadius: '6px',
							fontSize: '0.875rem',
							fontWeight: 500,
						}}
						data-tag-id={AppointmentBookingEnum.SELECIONOU_HORARIO_DISPONIVEL}
						onClick={() => onSelectHour(hour)}>
						{getFormattedHour(hour, flowType)}
					</Button>
				))}
			</StyledHourList>

			{showToggle ? (
				<Stack direction="row" alignItems="center" gap={1.25}>
					<Divider sx={{flex: 1}} />
					<Button
						variant="outlined"
						size="small"
						aria-expanded={isExpanded}
						aria-controls={hourListId}
						onClick={handleToggleExpanded}
						sx={{
							minHeight: 28,
							px: 1,
							borderRadius: '6px',
							fontSize: '0.75rem',
							fontWeight: 500,
							color: 'text.secondary',
							borderColor: 'divider',
							bgcolor: 'background.paper',
						}}>
						{isExpanded ? seeLess : seeMoreSchedules}
					</Button>
					<Divider sx={{flex: 1}} />
				</Stack>
			) : null}
		</Stack>
	);
}
